import PasswordIndicator from './react-password-indicator';

PasswordIndicator.default = PasswordIndicator;

export default PasswordIndicator;
